import {
  Step2AxleDetailsForm,
} from '@saf/saf-kundenportal-frontend-api/models/Step2AxleDetailsForm'
import { array, mixed, object, string } from 'yup'
import { invalidSerialNumber, mandatoryField } from '~shared/translations/yupSchemaErrors'
import { AxleComponentType } from '@saf/saf-kundenportal-frontend-api/models/AxleComponentType'

const serialNumberRegExp = /^([0-9]{8,9}|[0-9]{11})$/ // genau 8,9 oder 11 Stellen (jeweils zwischen 0 und 9)

export const Step2AxleDetailsSchema = object<Step2AxleDetailsForm>({
  serialNumber: string().required(mandatoryField).matches(serialNumberRegExp, invalidSerialNumber),
  axleComponent: array().of<AxleComponentType>(mixed<AxleComponentType>()).required(mandatoryField),
  optionalInfo: string(),
}).defined()
